import {
  GENERATE_QUIZ_GROUP,
  CREATE_OR_UPDATE_QUIZ_GROUP,
  PUBLISH_QUIZ_GROUP,
  UPDATE_QUIZ_GROUP,
  GENERATE_QUIZ_UPLOAD_URL,
  REMOVE_QUESTION_FROM_QUIZ_MUTATION,
  VERIFY_QUIZ_GROUP_UPLOAD_TOKEN,
  SUBMIT_QUIZ_RESPONSE,
} from "./Mutations";
import {
  GET_ALL_QUIZ_GROUPS,
  GET_QUIZ_GROUP,
  CHECK_FOR_EXISTING_RESPONSE,
  GET_QUIZ_GROUP_SUBMISSIONS,
  GET_QUIZ_QLA,
} from "./Queries";

export class QuizClient {
  constructor(client) {
    this.client = client;
  }

  async getQuizGroup({ quizGroup }) {
    const res = await this.client.query({
      query: GET_QUIZ_GROUP,
      variables: { quizGroup },
      fetchPolicy: "network-only",
    });
    return res.data;
  }

  async getAllQuizGroups({
    schoolClass = null,
    isPublished = null,
    showAllClasses = false,
    searchString = "",
    selectedStatus = "",
    first = 12,
    after = null,
  } = {}) {
    const res = await this.client.query({
      query: GET_ALL_QUIZ_GROUPS,
      variables: {
        schoolClass,
        isPublished,
        showAllClasses,
        searchString,
        selectedStatus,
        first,
        after,
      },
      fetchPolicy: "network-only",
    });
    return res.data.quizGroups;
  }

  async generateQuizGroup({
    schoolClass,
    payload,
    quizContext,
    name,
    description,
    dueDate,
    files,
    assignment,
    quizGroup,
  }) {
    const res = await this.client.mutate({
      mutation: GENERATE_QUIZ_GROUP,
      variables: {
        schoolClass,
        name,
        description,
        dueDate,
        payload,
        quizContext,
        files,
        assignment,
        quizGroup,
      },
    });
    return res.data.generateQuizGroup;
  }
  async publishQuiz({ quizGroup }) {
    const res = await this.client.mutate({
      mutation: PUBLISH_QUIZ_GROUP,
      variables: {
        quizGroup,
      },
    });
    return res.data.publishQuizGroup;
  }

  async createOrUpdateQuizGroup({
    schoolClass,
    quizGroup,
    quizContext,
    name,
    description,
    dueDate,
    questions,
  }) {
    const res = await this.client.mutate({
      mutation: CREATE_OR_UPDATE_QUIZ_GROUP,
      variables: {
        schoolClass,
        name,
        description,
        dueDate,
        quizGroup,
        quizContext,
        questions,
      },
    });
    return res.data.createOrUpdateQuizGroup;
  }

  async removeQuestion({ quiz, question }) {
    const res = await this.client.mutate({
      mutation: REMOVE_QUESTION_FROM_QUIZ_MUTATION,
      variables: { quiz, question },
    });
    return res.data.removeQuestionFromQuiz;
  }
  async updateQuizGroup({ quizGroup, dueDate, tags }) {
    const res = await this.client.mutate({
      mutation: UPDATE_QUIZ_GROUP,
      variables: { quizGroup, dueDate, tags },
    });
    return res.data.updateQuizGroup;
  }

  async generateQuizGroupUploadUrl({ quizGroup }) {
    const res = await this.client.mutate({
      mutation: GENERATE_QUIZ_UPLOAD_URL,
      variables: {
        quizGroup,
      },
    });
    return res.data.generateQuizGroupUploadUrl;
  }

  async verifyUploadToken({ user, token, quizGroup }) {
    const res = await this.client.mutate({
      mutation: VERIFY_QUIZ_GROUP_UPLOAD_TOKEN,
      variables: {
        user,
        token,
        quizGroup,
      },
    });
    return res.data.verifyQuizGroupUploadToken;
  }
  async submitQuizResponse({ identifier, quiz, payload }) {
    const res = await this.client.mutate({
      mutation: SUBMIT_QUIZ_RESPONSE,
      variables: {
        identifier,
        quiz,
        payload,
      },
    });
    return res.data.submitQuizResponse;
  }
  async checkForExistingResponses({
    identifier,
    quizGroup,
    teacherView = false,
  }) {
    const res = await this.client.mutate({
      mutation: CHECK_FOR_EXISTING_RESPONSE,
      variables: {
        identifier,
        quizGroup,
        teacherView,
      },
    });
    return res.data;
  }

  pollQuizGroupSubmissions({ quizGroup, pollInterval = 5000, onUpdate }) {
    return this.client
      .watchQuery({
        query: GET_QUIZ_GROUP_SUBMISSIONS,
        variables: { quizGroup },
        pollInterval,
        fetchPolicy: "network-only",
      })
      .subscribe({
        next: ({ data }) => onUpdate(data.quizGroupSubmissions),
        error: (error) => console.error("Polling error:", error),
      });
  }

  pollQuizQuestionAnalysis({ quiz, pollInterval = 5000, onUpdate }) {
    return this.client
      .watchQuery({
        query: GET_QUIZ_QLA,
        variables: { quiz },
        pollInterval,
        fetchPolicy: "network-only",
      })
      .subscribe({
        next: ({ data }) => onUpdate(data.quizQuestionLevelAnalysis),
        error: (error) => console.error("Polling error:", error),
      });
  }
}
